import { render, staticRenderFns } from "./caspanel.vue?vue&type=template&id=63130972&"
import script from "./caspanel.vue?vue&type=script&lang=js&"
export * from "./caspanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports